import { useState } from "react"
import { useInventory } from "../utils/inventory"
import { usePhotoInventory } from "../utils/photoinventory"
import { useConfig } from "../utils/useconfig"
import { useGeo } from "../utils/usegeo"
import { useInitialData } from "../utils/useinitialdata"
import { useFullscreen } from "./FullscreenPicture"
import { GeolocationNeededModal, OneButtonModal } from "./Modal"
import { Photoicon } from "./Photoicon"

function IntroModalSequence(){
    const [initialData,setInitialData] = useInitialData(store=>store)
    const [inventoryIsEmpty, setInventory] = useInventory(store => store.length == 0)
    const [photoInventoryIsEmpty] = usePhotoInventory(store => store.length == 0)
    const isLaunchedFromHomescreen = launchedFromHomeScreen()
    const [skipPhotoIntro, setSkipPhotoIntro] = useState(false)
    const [_,setFullscreen] = useFullscreen()
    const [config] = useConfig()
  
    const {geo} = useGeo()
  
    
    try {
      if(initialData.firstVisit && config?.intro_movie) {
        setInitialData({type:"FIRST_VISIT"})
        setFullscreen({src:config.intro_movie})
        return null;
      } 
    } catch(err){
      console.log(err)
    }
    
    if(!initialData.avatar && config?.avatars?.length) return <AvatarChoiceModal avatars={config.avatars} onChoice={(avatar:string)=>setInitialData({type:"AVATAR",avatar})} />
  
    if(inventoryIsEmpty) return <InventoryInfoModal onClick={()=>setInventory({type:"init",item:config?.first_item})} />
    if(photoInventoryIsEmpty && !skipPhotoIntro)return <PhotoInventoryInfoModal onClick={()=>setSkipPhotoIntro(true)} />
  
  
    if(geo.state === 'UNKNOWN' || geo.watcherId === undefined)return <GeolocationNeededModal />
  
    //if(!isLaunchedFromHomescreen)return <InstallAppModal />
  
    return null;
  }
  
  function AvatarChoiceModal({avatars,onChoice}:{avatars:string[],onChoice:(avatar:string)=>void}){
    const [config] = useConfig()

    return <OneButtonModal title={config?.intro_avatar_selector_title}>
      {
        avatars.map(avatar => <div key={avatar} className='avatarChoiceItem' onClick={()=>onChoice(avatar)}><img src={avatar}></img></div>)
      }
    </OneButtonModal>
  }
  
  function InventoryInfoModal({onClick}:{onClick:()=>void}){
    const [config] = useConfig()
    
    return <OneButtonModal title ={config?.intro_first_task?.title} buttonTitle={config?.intro_first_task?.button} buttonClick={onClick}>
      {config?.intro_first_task?.text}
    </OneButtonModal>
  }
  
  function PhotoInventoryInfoModal({onClick}:{onClick:()=>void}){
    const [config] = useConfig()
    let text = config?.intro_photo_task?.text?.split('###ICON###') ?? []
    if(text.length == 2){ //todo: ugly hack!
        text = [text[0],<Photoicon />,text[1]]
    }

    return <OneButtonModal title ={config?.intro_photo_task?.title} buttonTitle={config?.intro_photo_task?.button} buttonClick={onClick}>
     {text}
    </OneButtonModal>
  }
  
  
  function launchedFromHomeScreen(){
    return false;
  }

  export {IntroModalSequence}